'use strict';

var copy = require('shallow-copy');

var addCounts = require('../lib/add-counts');
var checklist = require('../refinement-types/checklist');

var refine = function refine(classifications, params, allCounts) {
  var counts = allCounts && allCounts.classification ? allCounts.classification : null;

  return {
    classification: classifications.map(function (classification) {
      var newClassification = addCounts({
        label: classification.description,
        value: String(classification.id)
      }, counts);

      var subClassValues = classification.subClassifications.map(function (subClassification) {
        return String(subClassification.id);
      });

      newClassification.isActive = checklist.includes(params, 'classification', newClassification.value);

      newClassification.refineParams = copy(params);
      if (newClassification.isActive) {
        subClassValues.forEach(function (value) {
          newClassification.refineParams = checklist.remove(newClassification.refineParams, 'subclassification', value);
        });
      }
      newClassification.refineParams = checklist.toggle(newClassification.refineParams, 'classification', newClassification.value);

      if (newClassification.isActive) {
        var subClassificationValues = classification.subClassifications.map(function (subClass) {
          return String(subClass.id);
        });

        var newSubClassifications = classification.subClassifications.map(function (subClass) {
          var newSubClassification = addCounts({
            type: 'subclassification',
            label: subClass.description,
            value: String(subClass.id)
          }, counts);

          newSubClassification.isActive = checklist.includes(params, 'subclassification', newSubClassification.value);

          newSubClassification.refineParams = copy(params);
          newSubClassification.refineParams = checklist.toggle(newSubClassification.refineParams, 'subclassification', newSubClassification.value);

          return newSubClassification;
        });

        var hasSelectedSubClass = newSubClassifications.some(function (subClass) {
          return subClass.isActive;
        });

        var allClassificationRefineParams = checklist.remove(params, 'subclassification', subClassificationValues);

        var allClassification = addCounts({
          type: 'all',
          value: newClassification.value,
          label: 'All ' + newClassification.label,
          isActive: !hasSelectedSubClass,
          refineParams: hasSelectedSubClass ? allClassificationRefineParams : checklist.remove(allClassificationRefineParams, 'classification', newClassification.value)
        }, counts);

        newClassification.children = [allClassification].concat(newSubClassifications);
      }

      // Don't show counts for expanded parent classifications
      if (newClassification.isActive) {
        delete newClassification.displayCount;
      }

      return newClassification;
    })
  };
};

module.exports = refine;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/refinements/classification.js
 ** module id = 499
 ** module chunks = 0
 **/